const diasDaSemana = {
  1: 'Dom',
  2: 'Seg',
  3: 'Ter',
  4: 'Qua',
  5: 'Qui',
  6: 'Sex',
  7: 'Sab',
};

const formataHora = hora =>
  hora
    .split(':')
    .splice(0, 2)
    .join(':')
    .concat('h');

const formataHorario = (inicio, fim) => {
  const horarioInicial = formataHora(inicio.horarioInicio);
  const horarioFinal = formataHora(fim.horarioFim);

  const horariosDiasSemana =
    inicio.diaSemana === fim.diaSemana
      ? `${diasDaSemana[inicio.diaSemana]} das `
      : `${diasDaSemana[inicio.diaSemana]} à ${diasDaSemana[fim.diaSemana]} `;

  return horariosDiasSemana.concat(`${horarioInicial} às ${horarioFinal}`);
};

const hasHorarioEquals = (inicio, fim) =>
  inicio.horarioInicio === fim.horarioInicio &&
  inicio.horarioFim === fim.horarioFim;

export const filtraHorarioEmbarque = horariosEmbarque => {
  const horarios = [];

  const horariosEmbarqueValido = horariosEmbarque.filter(
    dia => dia.ocorreEmbarque
  );

  if (horariosEmbarqueValido.length === 0) return horarios; // Não a horários de embarque

  const ultimo =
    horariosEmbarqueValido[horariosEmbarqueValido.length - 1].diaSemana;
  let inicio = horariosEmbarqueValido[0].diaSemana - 1;
  let proximo = inicio + 1;
  let insertPendente = false;

  while (proximo <= ultimo) {
    // valida se os dias ocorrem embarque
    if (
      proximo < ultimo &&
      horariosEmbarque[inicio].ocorreEmbarque &&
      horariosEmbarque[proximo].ocorreEmbarque
    ) {
      // se os dois dias tem horários semelhantes, se tiver ele pula para o próximo dia
      if (
        hasHorarioEquals(horariosEmbarque[inicio], horariosEmbarque[proximo])
      ) {
        insertPendente = true;
        proximo += 1;
        // eslint-disable-next-line no-continue
        continue;
      }
    }
    // se tem inserção pendente de horario ou se for o ultimo
    if (
      insertPendente ||
      proximo === ultimo ||
      horariosEmbarque[inicio].ocorreEmbarque
    ) {
      horarios.push({
        key: inicio,
        field: formataHorario(
          horariosEmbarque[inicio],
          horariosEmbarque[proximo - 1]
        ),
      });
      inicio = proximo;
      insertPendente = false;
    } else {
      inicio = proximo;
    }
    proximo += 1;
  }
  return horarios;
};
